export const FLAVOUR_PHASE_EVENT = 'nova:flavourphasechange'

export const FLAVOUR_IDS = [
  'deep-space',
  'ancient-spark',
  'event-horizon',
] as const

export type FlavourId = (typeof FLAVOUR_IDS)[number]

export type FlavourPhase =
  | 'before'
  | 'intro'
  | FlavourId
  | 'outro'
  | 'after'

export type FlavourPhaseSource = 'initial' | 'scroll' | 'gesture'

export type FlavourPhaseDetail = {
  phase: FlavourPhase
  previousPhase: FlavourPhase | null
  source: FlavourPhaseSource
}

export const isFlavourId = (value: string): value is FlavourId =>
  (FLAVOUR_IDS as readonly string[]).includes(value)

export const isFlavourPhase = (value: string): value is FlavourPhase =>
  value === 'before' ||
  value === 'intro' ||
  value === 'outro' ||
  value === 'after' ||
  isFlavourId(value)

export const getFlavourIndex = (phase: FlavourPhase) =>
  isFlavourId(phase) ? FLAVOUR_IDS.indexOf(phase) : -1
